import { render } from "./RichTextEditor.vue?vue&type=template&id=2d67332c"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=2d67332c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__